import * as React from 'react';

export interface IBaseAvatarProps {
  src?: string;
  username: string;
  online?: boolean;
  className?: string;
}

const avatarDefault = process.env.REACT_APP_IMG_DEFAULT;

export default function BaseAvatar(props: IBaseAvatarProps) {
  return (
    <div
      className={`relative rounded-full bg-slate-300 overflow-hidden w-10 h-10 flex justify-center 
      border-2 border-white flex-none
items-center font-bold ${props.className}`}
    >
      {props.src ? (
        <img
          className="w-full h-full"
          src={props.src}
          alt=""
          onError={(e: any) => {
            if (e.target.src !== avatarDefault) {
              e.target.src = avatarDefault;
            }
          }}
        />
      ) : (
        props?.username?.slice(0, 1)?.toUpperCase()
      )}
      <ShowOnline online={props.online} />
    </div>
  );
}

function ShowOnline(props: { online?: boolean }) {
  if (typeof props.online === 'boolean') {
    return (
      <div
        className={`absolute bottom-0 right-0 z-10 w-2 h-2 rounded-full mr-[2px] mb-[2px] ${
          props.online ? 'bg-green-500' : 'bg-red-500'
        }`}
      />
    );
  }
  return <></>;
}
